import { FastlyImage } from '@components/common/image'
import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { SizeType } from '@components/atoms/button'
import { Trans } from '@lingui/macro'

type Props = {
  isCoursePage?: boolean
  urlQuery?: string
  ctaSize?: SizeType
  shouldScrollToTop?: boolean
  isCodingCampPage?: boolean
}

export const Investors = ({
  isCoursePage,
  urlQuery,
  ctaSize,
  shouldScrollToTop,
  isCodingCampPage,
}: Props) => {
  const PATH = '/images/book-trial-class-jp'
  const investors = [
    'yc',
    'rb',
    'gsf',
    'java-capital',
    'nurture-ventures',
    'day-one',
    'wefunder',
    'ms',
  ]
  return (
    <div className="relative">
      <div className="container mx-auto">
        <div
          className={`flex flex-col relative my-6 py-6 lg:my-8 lg:py-8 rounded-2xl ${
            !isCoursePage && 'items-center'
          }`}
        >
          <h2
            className={`text-grey font-600 ${
              isCoursePage
                ? 'text-2xl text-left'
                : 'text-2xl leading-tight text-center lg:text-4xl'
            }`}
          >
            <Trans>Codingal is backed by esteemed angel investors</Trans>
          </h2>
          <p
            className={`text-lg pt-3 ${
              isCoursePage ? 'text-left' : 'text-center px-4'
            }`}
          >
            <Trans>
              Codingal has secured substantial backing from renowned investment
              firms and a host of prominent angel investors.
            </Trans>
          </p>
          <div className="mt-5 w-full md:w-auto">
            <div
              className={`flex flex-wrap items-center justify-center md:gap-3 gap-2 my-3 md:pt-0 w-full md:w-auto ${
                isCoursePage ? '' : 'p-4 md:p-10'
              }`}
            >
              {investors.map((e, i) => (
                <div key={i} className="max-w-2/6">
                  {' '}
                  <FastlyImage
                    src={`${PATH}/${e}.png`}
                    webpSrc={`${PATH}/${e}.webp`}
                  />
                </div>
              ))}
            </div>
          </div>
          {!isCodingCampPage && (
            <>
              {!isCoursePage && (
                <div className="w-full flex justify-center px-5">
                  <BookFreeClassBtn
                    className="w-full"
                    shouldScrollToTop={shouldScrollToTop}
                    size={ctaSize}
                    query={urlQuery}
                  />
                </div>
              )}
              {isCoursePage && (
                <div className="mx-auto w-full md:max-w-xs text-center mt-5">
                  <BookFreeClassBtn query={urlQuery} size={ctaSize} />
                </div>
              )}
            </>
          )}

          {isCodingCampPage && (
            <div className="flex justify-center pt-8 w-full px-5 mx-auto">
              {' '}
              <a
                className="text-center btn btn-orange w-full md:w-auto py-3 text-lg"
                href="#courses"
              >
                Claim your spot now
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
